import { useState, useEffect, useCallback } from "react";
import { request } from "../api/http";
export default function useResource(path) {
  const [data, setData] = useState(null),
    [error, setError] = useState(""),
    [loading, setLoading] = useState(true),
    [version, setVersion] = useState(0);
  const reload = useCallback(() => setVersion((v) => v + 1), []);
  useEffect(() => {
    const c = new AbortController();
    let live = true;
    setLoading(true);
    setError("");
    const timer = setTimeout(
      () =>
        request(path, { signal: c.signal })
          .then((d) => {
            if (live) setData(d);
          })
          .catch((e) => {
            if (live && e.name !== "AbortError") setError(e.message);
          })
          .finally(() => {
            if (live) setLoading(false);
          }),
      250
    );
    return () => {
      live = false;
      clearTimeout(timer);
      c.abort();
    };
  }, [path, version]);
  return { data, error, loading, reload };
}
